module.exports = __webpack_public_path__ + "3_17_13_21_27/img/index-information-bj.14447cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-information-bj.png
// module id = 0AdJ
// module chunks = 1